import InputCus from "../../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  ProductCreateBerand,
  ProductFilterBerand,
  ProductUpdateBerand,
} from "../../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

function BerandAE() {
  const [isLoading, setLoading] = useState(true);
  const [form, setForm] = useState({});

  const navigate = useNavigate();

  let { id } = useParams();
  const start = async () => {
    try {
      if (id) {
        const FilterBerandDataData = await ProductFilterBerand({
          id: id,
        });
        if (
          FilterBerandDataData.status &&
          FilterBerandDataData.status === 200
        ) {
          setForm(FilterBerandDataData.data.data.data[0]);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    let validation = true;
    if (form.name === "") {
      toast.error("نام را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        if (id) {
          const UpdateBerandData = await ProductUpdateBerand(form);
          if (UpdateBerandData.status && UpdateBerandData.status === 200) {
            toast.success("بروزرسانی با موفقیت انجام شد");
            navigate("/Panel/Products/Berand");
          }
        } else {
          const CreateBerandData = await ProductCreateBerand(form);
          if (CreateBerandData.status && CreateBerandData.status === 200) {
            toast.success("افزودن  با موفقیت انجام شد");
            navigate("/Panel/Products/Berand");
          }
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-column w-100">
              <InputCus
                className="m-2"
                type="text"
                name="name"
                id="name"
                text="نام"
                value={form.name || ""}
                onChange={handleChangeSearch}
              />
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                {id ? "ویرایش" : "افزودن"}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BerandAE;
